<template>
  <div>
    <shimmer
      v-if="withTitle"
      height="0.9rem"
      width="30%"
      class="mb-1"
      :rounded="true"
    ></shimmer>
    <shimmer
      width="100%"
      :rounded="true"
      height="0.9rem"
      class="line-box"
    ></shimmer>
    <shimmer
      :width="justified ? '100%' : '90%'"
      :rounded="true"
      height="0.9rem"
      class="line-box"
    ></shimmer>
  </div>
</template>
<script>
import shimmer from '@/components/shimmers/shimmer'

export default {
  components: {
    shimmer
  },
  props: {
    withTitle: {
      default: false,
      type: Boolean
    },
    justified: {
      default: false,
      type: Boolean
    }
  }
}
</script>

<style scoped>
.line-box {
  height: 1.25rem;
}
</style>
